import { Button, makeStyles, Paper, Typography, Grid } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { created_by } from "../../../shared-resources/dumpData";
import {
  dateFormats,
  months,
  timeZones,
} from "../../../shared-resources/dumpData";
import CustomSelect from "../../../common-components/CustomSelect";
import CustomTextField from "../../../common-components/CustomTextField";
import CustomDatePicker from "../../../common-components/CustomDatePicker";
import {
  getGeneralSettings,
  updateGeneralSettings,
  getGeneralSettingsLocation,
} from "../../../actions/admin-actions";
import Loading from "../../../common-components/Loading";
import ActionMessages from "../../../common-components/ActionMessages";
import SettingsList from "./SettingsList";
import {
  getResponse,
  converDateFormatForPicker,
  formatDateBySetting,
} from "../../../shared-resources/utils";

const useStyles = makeStyles((theme) => ({
  componentPaper: {
    borderRadius: "12px",
    padding: "20px",
  },
  legendHeader: {
    color: "#0070D2",
    fontWeight: 600,
    fontSize: "14px",
  },
  formGrid: {
    margin: "20px 0 0 0",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.25),
    fontSize: "13px",
  },
  cancelBtn: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
  createBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "16px",
  },
  actionBtns: {
    margin: "16px 0 8px 0",
  },
}));

export default function GeneralSettings({ page }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedPage, setSelectedPage] = useState("Main");
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    date_format: "",
    timezone: "",
    financial_year_start: "",
    financial_year_name: "",
    max_available_fte: 0,
    defaultFinancialYear: 0,
  });
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isSaveClick, setIsSaveClick] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [locationTree, setLocationTree] = useState([]);
  const [years, setYears] = useState([]);
  const [dateFormat, setDateFormat] = useState("dd/MM/yyyy");

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData
  );

  const updateGeneralSettingsData = useSelector(
    (state) => state.adminReducer.updateGeneralSettingsData
  );

  const locationSettingsData = useSelector(
    (state) => state.adminReducer.locationSettingsData
  );

  const onDataChange = (e, item) => {
    const val = e.target.value;
    if (item === "max_available_fte") {
      const validNumber = new RegExp(/^\d*\.?\d*$/);
      if (!validNumber.test(val)) return;
      if (
        val.toString().includes(".") &&
        val.toString().split(".")[1].length > 2
      )
        return;
    }
    const dataToChange = JSON.parse(JSON.stringify(formData));
    dataToChange[item] = val;
    setFormData(dataToChange);
    if (val === "") setIsEnabled(false);
    else setIsEnabled(true);
  };

  useEffect(() => {
    const childSelected = page.children.filter((val) => val.isSelected);
    if (childSelected.length > 0) {
      setSelectedPage(childSelected[0].page);
    } else setSelectedPage("Main");
  }, [page]);

  useEffect(() => {
    dispatch(getGeneralSettingsLocation());
  }, []);

  useEffect(() => {
    if (
      generalSettingsData.status &&
      (generalSettingsData.status === 200 ||
        generalSettingsData.status === 400) &&
      locationSettingsData.status &&
      (locationSettingsData.status === 200 ||
        locationSettingsData.status === 400)
    ) {
      setLoading(false);
      if (getResponse(generalSettingsData))
        setFormData(getResponse(generalSettingsData)[0]);
      const startMonth = getResponse(generalSettingsData, [])[0]
        .financial_year_start;
      let start = 0;
      if (startMonth) {
        if (startMonth === "February") start = 1;
        if (startMonth === "March") start = 2;
        if (startMonth === "April") start = 3;
        if (startMonth === "May") start = 4;
        if (startMonth === "June") start = 5;
        if (startMonth === "July") start = 6;
        if (startMonth === "August") start = 7;
        if (startMonth === "September") start = 8;
        if (startMonth === "October") start = 9;
        if (startMonth === "November") start = 10;
        if (startMonth === "December") start = 11;
      }
      let startYear = new Date().getFullYear();
      if (new Date().getMonth() < start) {
        startYear = startYear - 1;
      }
      if (start === 0)
        setYears([
          { text: startYear - 2, id: startYear - 2 },
          { text: startYear - 1, id: startYear - 1 },
          { text: startYear, id: startYear },
          { text: startYear + 1, id: startYear + 1 },
          { text: startYear + 2, id: startYear + 2 },
        ]);
      else
        setYears([
          { text: startYear - 1, id: startYear - 2 },
          { text: startYear, id: startYear - 1 },
          { text: startYear + 1, id: startYear },
          { text: startYear + 2, id: startYear + 1 },
          { text: startYear + 3, id: startYear + 2 },
        ]);
      setDateFormat(
        converDateFormatForPicker(
          getResponse(generalSettingsData, [])[0].date_format
        )
      );
      if (
        locationSettingsData.status &&
        (locationSettingsData.status === 200 ||
          locationSettingsData.status === 400)
      ) {
        setLocationTree(getResponse(locationSettingsData, []));
      }
    }
  }, [generalSettingsData, locationSettingsData]);

  useEffect(() => {
    if (
      updateGeneralSettingsData.status &&
      (updateGeneralSettingsData.status === 200 ||
        updateGeneralSettingsData.status === 400) &&
      isSaveClick
    ) {
      setLoading(false);
      setEmptyErrMsg(true);
      setMsgType("success");
      setMsgText("Settings updated successfully");
      setIsSaveClick(false);
      setIsEnabled(false);
      dispatch(getGeneralSettings());
    }
  }, [updateGeneralSettingsData]);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const onSaveClick = () => {
    setIsSaveClick(true);
    if (
      new Date(formData.pmDefaultStartDate) >
      new Date(formData.pmDefaultEndDate)
    ) {
      setEmptyErrMsg(true);
      setMsgText("Start date shouldn't be greater than end date");
      setMsgType("error");
      return false;
    }
    if (
      new Date(formData.rmDefaultStartDate) >
      new Date(formData.rmDefaultEndDate)
    ) {
      setEmptyErrMsg(true);
      setMsgText("Start date shouldn't be greater than end date");
      setMsgType("error");
      return false;
    }
    setLoading(true);
    const dataToChange = JSON.parse(JSON.stringify(formData));
    if (!dataToChange.created_by) dataToChange.created_by = created_by;
    dataToChange.modified_date = new Date();
    dataToChange.modified_by = created_by;
    dispatch(updateGeneralSettings([dataToChange]));
  };

  const cancelClick = () => {
    setIsEnabled(false);
    if (getResponse(generalSettingsData))
      setFormData(getResponse(generalSettingsData)[0]);
  };

  const getDate = (date) => {
    if (date && date !== "") {
      const dateVal = formatDateBySetting(new Date(date), "YYYY-MM-DD");
      return dateVal;
    }
    return null;
  };

  const dateChange = (val, key) => {
    const changeData = JSON.parse(JSON.stringify(formData));
    changeData[key] = val ? getDate(val) : null;
    setFormData(changeData);
    if (
      changeData.pmDefaultEndDate &&
      changeData.pmDefaultStartDate &&
      changeData.rmDefaultStartDate &&
      changeData.rmDefaultEndDate
    )
      setIsEnabled(true);
    else setIsEnabled(false);
  };
  return (
    <>
      {selectedPage === "Main" ? (
        <Paper elevation={0} className={classes.componentPaper}>
          <Typography className={classes.legendHeader}>
            Date & Time Settings
          </Typography>
          <Grid container spacing={0} className={classes.formGrid}>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Date Format</div>
              <CustomSelect
                selectedValue={formData.date_format || ""}
                onChangeItem={(e) => onDataChange(e, "date_format")}
                labelVal="Date Format"
                id="dateFormat"
                items={dateFormats}
                width="80%"
              />
            </Grid>
            {/*<Grid item lg={4}>
              <div className={classes.fieldTitle}>Time Settings</div>
              <CustomSelect
                selectedValue={formData.timezone || ""}
                onChangeItem={(e) => onDataChange(e, "timezone")}
                labelVal="Time Settings"
                id="timeSettings"
                items={timeZones}
                width="80%"
              />
            </Grid>*/}
          </Grid>
          <Typography
            className={classes.legendHeader}
            style={{ marginTop: "28px" }}
          >
            Financial Year Settings
          </Typography>
          <Grid container spacing={0} className={classes.formGrid}>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Financial Year Start</div>
              <CustomSelect
                selectedValue={formData.financial_year_start || ""}
                onChangeItem={(e) => onDataChange(e, "financial_year_start")}
                labelVal="Financial Year Start"
                id="financialYearStart"
                items={months}
                width="80%"
              />
            </Grid>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Financial Year</div>
              <CustomSelect
                selectedValue={formData.defaultFinancialYear || ""}
                onChangeItem={(e) => onDataChange(e, "defaultFinancialYear")}
                labelVal="Financial Year"
                id="financialYear"
                items={years}
                width="80%"
              />
            </Grid>
            {/* <Grid item lg={4}>
              <div className={classes.fieldTitle}>Financial Year Name</div>
              <CustomTextField
                selectedValue={formData.financial_year_name || ""}
                onChangeItem={(e) => onDataChange(e, "financial_year_name")}
                labelVal="Financial Year Name"
                id="financialYearName"
                itemWidth="80%"
              />
            </Grid>*/}
          </Grid>
          <Typography
            className={classes.legendHeader}
            style={{ marginTop: "28px" }}
          >
            Project Management Settings
          </Typography>
          <Grid container spacing={0} className={classes.formGrid}>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Default Start Date</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={formData.pmDefaultStartDate}
                setDateValue={(date) => dateChange(date, "pmDefaultStartDate")}
                itemWidth="80%"
                classVal={
                  isSaveClick &&
                  (!formData.pmDefaultStartDate ||
                    new Date(formData.pmDefaultStartDate) >
                      new Date(formData.pmDefaultEndDate))
                    ? "datePickerError"
                    : "datePicker"
                }
                disableWeekends={false}
              />
            </Grid>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Default End Date</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={formData.pmDefaultEndDate}
                setDateValue={(date) => dateChange(date, "pmDefaultEndDate")}
                itemWidth="80%"
                classVal={
                  isSaveClick &&
                  (!formData.pmDefaultEndDate ||
                    new Date(formData.pmDefaultStartDate) >
                      new Date(formData.pmDefaultEndDate))
                    ? "datePickerError"
                    : "datePicker"
                }
                disableWeekends={false}
              />
            </Grid>
          </Grid>
          <Typography
            className={classes.legendHeader}
            style={{ marginTop: "28px" }}
          >
            Resource Management Settings
          </Typography>
          <Grid container spacing={0} className={classes.formGrid}>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Default Start Date</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={formData.rmDefaultStartDate}
                setDateValue={(date) => dateChange(date, "rmDefaultStartDate")}
                itemWidth="80%"
                classVal={
                  isSaveClick &&
                  (!formData.rmDefaultStartDate ||
                    new Date(formData.rmDefaultStartDate) >
                      new Date(formData.rmDefaultEndDate))
                    ? "datePickerError"
                    : "datePicker"
                }
                disableWeekends={false}
              />
            </Grid>
            <Grid item lg={4}>
              <div className={classes.fieldTitle}>Default End Date</div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={formData.rmDefaultEndDate}
                setDateValue={(date) => dateChange(date, "rmDefaultEndDate")}
                itemWidth="80%"
                classVal={
                  isSaveClick &&
                  (!formData.rmDefaultEndDate ||
                    new Date(formData.rmDefaultStartDate) >
                      new Date(formData.rmDefaultEndDate))
                    ? "datePickerError"
                    : "datePicker"
                }
                disableWeekends={false}
              />
            </Grid>
          </Grid>
          <Typography
            className={classes.legendHeader}
            style={{ marginTop: "28px" }}
          >
            FTE Settings
          </Typography>
          <Grid container spacing={0} className={classes.formGrid}>
            <Grid item lg={2}>
              <div className={classes.fieldTitle}>Maximum Allowed FTE</div>
              <CustomTextField
                selectedValue={formData.max_available_fte || ""}
                onChangeItem={(e) => onDataChange(e, "max_available_fte")}
                id="financialYearName"
                itemWidth="50%"
              />
            </Grid>
          </Grid>
          <div className={classes.actionBtns}>
            <Button
              size="small"
              color="primary"
              variant="contained"
              disableElevation
              className={classes.createBtn}
              onClick={onSaveClick}
              disabled={!isEnabled}
            >
              Save Details
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtn}
              color="primary"
              onClick={cancelClick}
            >
              Cancel
            </Button>
          </div>
          {loading && <Loading />}
          {emptyErrMsg && (
            <ActionMessages
              type={msgType}
              isClosed={isClosed}
              message={msgText}
            />
          )}
        </Paper>
      ) : (
        <SettingsList data={locationTree} type="Locations" />
      )}
    </>
  );
}
